// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"4875cf97","454":"2f5dacaf","500":"e02451a1","592":"0c9395f9","952":"c7526657"}[chunkId] + ".chunk.js";
};